// extracted by mini-css-extract-plugin
module.exports = {"marketplaceRouter":"_1Wolw","marketplaceRouterEditor":"fRro6","marketplaceRouterSa":"_3lLwR"};